
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';
  import DlgGuestNew from '@/modules/user/guests/_components/DlgGuestNew.vue';
  import DlgGuestSelector from '@/modules/user/guests/_components/DlgGuestSelector.vue';

  @Component({
    components: {DlgGuestSelector, DlgGuestNew, Card},
  })
  export default class EventGuests extends Vue {
    public $refs!: {
      form: any,
      dlgGroup: any,
      dlgGuests: any,
    };
    @Prop({type: String, default: ''}) private search!: string;

    @Action('user/events/readGuests') private readGuests!: (params: any) => Promise<any>;
    @Action('user/events/addGuests') private addGuests!: (params: any) => Promise<any>;
    @Action('user/groups/readOne') private readGroup!: (params: any) => Promise<any>;

    @Getter('user/events/one') private event!: any;
    @Getter('user/groups/one') private group!: any;
    @Getter('user/events/guests') private guests!: any;

    private guestSearch: string = '';
    private loading: boolean = false;
    private sendGuestEmailGuest: object = {};
    private sendGuestEmailDlg: boolean = false;

    private headers: any = [
      {
        text: 'Status',
        value: 'status',
        align: 'left',
      },
      {
        text: 'Email',
        align: 'left',
        value: 'email',
      },
      {
        text: 'Name',
        value: 'surname',
        align: 'left',
      },
      {
        text: 'Eingeladen durch',
        value: 'invitedBy',
        align: 'left',
      },
      {
        text: 'Email Status',
        value: 'emailStatus',
        align: 'left',
      },
    ];

    private async mounted() {
      this.loading = true;
      await this.readGuests({id: this.event.id});
      this.loading = false;
    }

    private async addGuest(guest) {
      this.loading = true;
      await this.addGuests({id: this.event.id, guests: [guest.id]});
      await this.readGuests({id: this.event.id});
      this.loading = false;
    }

    private async selectedGuest(guest) {
      this.loading = true;
      await this.addGuests({id: this.event.id, guests: [guest.id]});
      await this.readGuests({id: this.event.id});
      this.$refs.dlgGuests.close();
      this.loading = false;
    }

    private guestSearchChanged(e) {
      this.guestSearch = e;
    }

    private async importGroup(group) {
      this.loading = true;
      await this.readGroup({id: group.id});

      const ids: string[] = [];

      this.group.members.forEach((member) => {
        ids.push(member.guestId);
      });

      await this.addGuests({id: this.event.id, guests: ids});
      this.$refs.dlgGroup.close();
      await this.readGuests({id: this.event.id});
      this.loading = false;
    }

    private sendGuestEmail(guest) {
      this.sendGuestEmailGuest = guest;
      this.sendGuestEmailDlg = true;
    }
  }
